import { render, staticRenderFns } from "./3DViewerTBD.vue?vue&type=template&id=193d3f04&scoped=true&"
import script from "./3DViewerTBD.vue?vue&type=script&lang=js&"
export * from "./3DViewerTBD.vue?vue&type=script&lang=js&"
import style0 from "./3DViewerTBD.vue?vue&type=style&index=0&id=193d3f04&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193d3f04",
  null
  
)

export default component.exports